/*
 * sonbpIF連携のお試し。
 * 
 * 【注意点】
 * SonbpIfの実体jsファイルは分離してあるため、import使うとブラウザ上での編集画面以外では SonbpIf⇒not defined エラーとなる。
 * コーディング中だけimportで型チェックを行い、ビルド時はdeclareで逃げるが手軽。
 * 
 */

//import * as SonbpIf from "SonbpIf";
declare var SonbpIf: any;
declare var sonbp: any;

export class SonbpIfTestDriver {

	public start() {

		// テスト用
		var prms = location.search.substring(1).split('&');
		for (var i = 0; prms[i]; i++) {
			var k = prms[i].split('=');
			prms[k[0]] = k[1];
		}

		// sonbp CanvsのdivId
		var box_view = "box_view";
		if (prms["box_view"]) box_view = prms["box_view"];

		// PC/SPモード
		var client = "PC";
		if (prms["client"]) client = prms["client"];

		if (client == "SP") {
			$("#box_contents").height("200px");
		}

		// [sonbp] ローディング UI表示
		// 画面いっぱいに、ロード中のUIを表示します。
		sonbp.ui.loading.init();
		sonbp.ui.loading.start();

		//SonbpIfClassは画面シングルトンで利用
		var sonbpIf = new SonbpIf.SonbpIfClass();
		document["_sonbpIf"] = sonbpIf;

		//オプション指定
		sonbpIf.setOption({
			put_range: {
				w: 248.17,	//87.55,
				h: 384.01	//135.47
			},
			put_range_stamp: {
				w: 283.846, // 立ち落としサイズ調整済
				h: 420,
			},
			page_offset: {
				x: 10,
				y: 10
			}
		});

		//セッションエラーコールバック
		sonbpIf.onApiError(function (e: any): boolean {

			console.log("onApiError", e);
			if (e.responseCode == 401) {
				console.log("セッションチェックＮＧ ");
			}
			return false;
		});

		//sonbp初期化
		sonbpIf.sonbpInit(null, box_view, "ffpsc/", "", client, "test_token_value", function (res) {
			if (res.code == 0) {

				//sonbp起動
				sonbpIf.sonbpStart(function (res) {
					if (res.code == 0) {

						// 処理モード設定
						sonbpIf.setMode("PHOTO_RGST", function (res) {
							if (res.code == 0) {

								//編集開始
								sonbp.ui.loading.stop();
							}
							else {

								console.error(res);
								displayNotice(res.msg);
							}
						});
					}
					else {

						console.error(res);
						displayNotice(res.msg);
					}
				});
			}
			else {

				console.error(res);
				displayNotice(res.msg);
			}
		});

		//エラー表示は業務側に任せる
		function displayNotice(msg) {
			alert("message: " + msg);
		}

		//---------------------------------------------------
		//連携テスト（基本動作）
		//---------------------------------------------------

		//sonbp初期化
		$("#sonbpInit").click(function () {
			document.location.href = "./sonbpiftest?box_view=" + $("#sonbpInit_box").val();
		});

		//sonbp起動
		$("#sonbpStart").click(function () {
			document.location.href = "./sonbpiftest?file_key=" + $("#sonbpStart_fkey").val();
		});

		//Canvasサイズ調整
		$("#resizeContents").click(function () {
			$("#box_contents").css("width", $("#resizeContents_w").val()).css("height", $("#resizeContents_h").val());

			let asize = ($("#resizeContents_asize").val() == "") ? undefined : Number($("#resizeContents_asize").val());
			sonbpIf.resizeContents(asize);
		});

		//処理モード切換え
		$("#posca_mode").on("change", function () {
			let preSel = sonbpIf.getSelectItem();
			sonbpIf.setMode($("#posca_mode").val(), function (res) {
				if (res.code != 0) {
					console.error(res);
					displayNotice(res.msg);
					return;
				}

				//debug SPのzoom確認用
				if (preSel != null && client == "SP" && $("#posca_mode").val() == "PHOTO_MANI") {
					sonbpIf.selectItem(
						preSel.item_type,
						preSel.idx,
						function (res) {
						});
				}
			});
		});

		//PDF保存
		$("#menu_save2").click(function () {
			if ($("#menu_save2_flg").prop("checked")) {
				//sonbpの中身壊してエラーにする
				(<any>sonbpIf)._ifdto.bpView._editToken = "dummy";
			}

			sonbp.ui.loading.start();
			sonbpIf.save(function (res) {
				if (res.code != 0) {
					console.error(res);
					displayNotice(res.msg);
				}
				sonbp.ui.loading.stop();
			});
			return false;
		});

		//仕上がり変更
		$("#setAreaView").click(function () {
			sonbpIf.setAreaView($("#setAreaView_type").val());
		});

		//レイヤー情報取得
		$("#getLayers").click(function () {
			var result = sonbpIf.getLayers();
			console.log("getLayers result -->", result);
		});

		//ページサイズ取得
		$("#getPageSize").click(function () {
			var result = sonbpIf.getPageSize();
			console.log("getPageSize result -->", result);
		});

		//---------------------------------------------------
		//連携テスト（アイテム操作／共通）
		//---------------------------------------------------

		//アイテム選択指示
		$("#selectItem").click(function () {
			sonbpIf.selectItem(
				$("#selectItem_type").val(),
				$("#selectItem_idx").val(),
				function (res) {
					console.log("selectItem result -->", res);
				});
		});

		//アイテム選択通知
		$("#onChangeSelectItem").click(function () {
			sonbpIf.onChangeSelectItem(function (vps) {
				console.log("onChangeSelectItem -->", vps);
			})
		});

		//選択アイテム取得
		$("#getSelectItems").click(function () {
			var result = sonbpIf.getSelectItem();
			console.log("getSelectItems result -->", result);
		});

		//アイテムリスト取得
		$("#getItems").click(function () {
			var prm = [];
			if ($("#getItems_type").val().length > 0) {
				prm = $("#getItems_type").val().split(',');
			}

			sonbpIf.getItems(prm, function (res, list) {
				console.log("getItems result -->", res, list);
			});
		});

		//アイテム回転
		$("#rotateItem").click(function () {
			sonbpIf.rotateItem(Number($("#rotateItem_deg").val()), function (res) {
				console.log("rotateItem result -->", res);
			});
		});

		//アイテム拡大縮小
		$("#scaleItem").click(function () {
			sonbpIf.scaleItem(Number($("#scaleItem_scale").val()), function (res) {
				console.log("scaleItem result -->", res);
			});
		});

		//アイテム移動
		$("#moveItem").click(function () {
			sonbpIf.moveItem(Number($("#moveItem_x").val()), Number($("#moveItem_y").val()), function (res) {
				console.log("moveItem result -->", res);
			});
		});

		//履歴初期化
		$("#historyStart").click(function () {
			let res = sonbpIf.historyStart();
			console.log("historyStart result -->", res);
		});

		//履歴Undo
		$("#historyAllUndo").click(function () {
			sonbpIf.historyAllUndo(function (res) {
				console.log("historyAllUndo result -->", res);
			});
		});

		//履歴Commit
		$("#historyCommit").click(function () {
			let res = sonbpIf.historyCommit();
			console.log("historyCommit result -->", res);
		});

		//---------------------------------------------------
		//連携テスト（アイテム操作／画像操作）
		//---------------------------------------------------

		//画像リスト取得
		$("#getPhotoList").click(function () {
			var prm = [];
			sonbpIf.getPhotoList(function (res, list) {
				console.log("getPhotoList result -->", res, list);
			});
		});

		//写真枠に画像を配置（カレント枠）
		$("#setPhoto").click(function () {
			var file_key = $("#setPhoto_fkey").val();
			var file_id = $("#setPhoto_fid").val()
			var keep_flg = $("#setPhoto_keep").prop("checked");
			EncodeFileKey(file_key, function (fkey) {
				sonbpIf.setPhoto(fkey, file_id, { w: 1024, h: 768 }, keep_flg, function (res) {
					console.log("setPhoto result -->", res);
				});
			});
		});

		//画像枠から配置画像削除（ID指定）
		$("#removePhotoById").click(function () {
			var file_id = $("#removePhotoById_fid").val().split(",");
			sonbpIf.removePhotoById(file_id, function (res) {
				console.log("removePhotoById result -->", res);
			});
		});

		//画像枠から配置画像削除（カレント枠）
		$("#removePhoto").click(function () {
			sonbpIf.removePhoto(function (res) {
				console.log("removePhoto result -->", res);
			});
		});

		//写真枠に画像を配置（ドラッグ＆ドロップ）
		var fids = ["cat-1057829_1920", "IMG_12", "Koala", "Koala_mini"];
		for (var i = 0; i < fids.length; i++) {
			let pureFileId = fids[i];
			let vpFileId = pureFileId + "@0";
			let file_key = "PHOTO@20210308@ID0003@" + pureFileId + "@on@0";
			EncodeFileKey(file_key, function (fkey) {
				let image = new Image();

				image.onload = function (e) {
					console.log(pureFileId);
				}

				image.ondragstart = function (e) {
					sonbpIf.setPhotoDragger(e, image, fkey, vpFileId, { w: image.naturalWidth, h: image.naturalHeight }, function (res) {
						console.log("setPhotoDragger result -->", res);
						if (res.ex) console.error(res.ex);
					});
				}

				image.title = pureFileId;
				image.src = "./SonbpIfTest/prev?fid=" + pureFileId;

				document.getElementById("setPhotoDragger_div").appendChild(image);
			});
		}
		//fake
		{
			let file_id = "Fake_file_key";
			let file_key = "PHOTO@20210308@ID0003@" + file_id + "@on@0";
			EncodeFileKey(file_key, function (fkey) {
				let image = new Image();

				image.ondragstart = function (e) {
					sonbpIf.setPhotoDragger(e, image, fkey, file_id, null, function (res) {
						console.log("setPhotoDragger result -->", res);
						if (res.ex) console.error(res.ex);
					});
				}

				image.title = file_id;
				image.src = "./SonbpIfTest/prev?fid=IMG_12";

				document.getElementById("setPhotoDragger_div").appendChild(image);
			});
		}

		//２つの画像を入れ替え（タッチ式）
		$("#mutualTradePhoto").click(function () {
			var idxA = $("#mutualTradePhoto_idxA").val();
			var idxB = $("#mutualTradePhoto_idxB").val();
			sonbpIf.mutualTradePhoto(idxA, idxB, function (res) {
				console.log("mutualTradePhoto result -->", res);
			});
		});

		//---------------------------------------------------
		//連携テスト（アイテム操作／スタンプ操作）
		//---------------------------------------------------

		//スタンプリスト取得
		$("#getStampList").click(function () {
			var prm = [];
			sonbpIf.getStampList(function (res, list) {
				console.log("getStampList result -->", res, list);
			});
		});

		//スタンプを配置
		$("#setStamp").click(function () {
			var idx = $("#setStamp_idx").val();
			var file_key = $("#setStamp_fkey").val();
			var file_id = $("#setStamp_fid").val();
			var w = Number($("#setStamp_w").val());
			var h = Number($("#setStamp_h").val());
			EncodeFileKey(file_key, function (fkey) {
				sonbpIf.setStamp("STAMP_IMG", idx, fkey, file_id, { w: w, h: h }, function (res) {
					console.log("setStamp result -->", res);
				});
			});
		});

		//マイスタンプを配置
		$("#setMyStamp").click(function () {
			var idx = $("#setMyStamp_idx").val();
			var file_key = $("#setMyStamp_fkey").val();
			var file_id = $("#setMyStamp_fid").val();
			var w = Number($("#setMyStamp_w").val());
			var h = Number($("#setMyStamp_h").val());
			EncodeFileKey(file_key, function (fkey) {
				sonbpIf.setStamp("MYSTAMP_IMG", idx, fkey, file_id, { w: w, h: h }, function (res) {
					console.log("setMyStamp result -->", res);
				});
			});
		});

		//手書きスタンプを配置
		$("#setFgStamp").click(function () {
			var idx = $("#setFgStamp_idx").val();
			var file_key = $("#setFgStamp_fkey").val();
			var file_id = $("#setFgStamp_fid").val();
			var w = Number($("#setFgStamp_w").val());
			var h = Number($("#setFgStamp_h").val());
			EncodeFileKey(file_key, function (fkey) {
				sonbpIf.setStampByFontGenic(idx, fkey, file_id, { w: w, h: h }, function (res) {
					console.log("setFgStamp result -->", res);
				});
			});
		});
		//手書きスタンプを配置（テストケース追加）
		$("#setFgStamp_sample_set").click(function () {
			var vals = $("#setFgStamp_sample").val().split(',');
			$("#setFgStamp_fkey").val("FONTGENIC@20210308@ID0003@" + vals[0]);
			$("#setFgStamp_fid").val(vals[0]);
			$("#setFgStamp_w").val(vals[1]);
			$("#setFgStamp_h").val(vals[2]);
		});

		//スタンプ削除（ID指定）
		$("#removeStampById").click(function () {
			var file_id = $("#removeStampById_fid").val().split(",");
			var item_type = $("#removeStampById_itemtype").val();
			sonbpIf.removeStampById(item_type, file_id, function (res) {
				console.log("removeStampById result -->", res);
			});
		});

		//スタンプ削除（カレント枠）
		$("#removeStamp").click(function () {
			sonbpIf.removeStamp(function (res) {
				console.log("removeStamp result -->", res);
			});
		});

		//---------------------------------------------------
		//連携テスト（アイテム操作／テキスト操作）
		//---------------------------------------------------

		//テキストリスト取得
		$("#getTextList").click(function () {
			var prm = [];
			sonbpIf.getTextList(function (res, list) {
				console.log("getTextList result -->", res, list);
			});
		});

		//テキストを配置
		$("#setText").click(function () {
			var itype = $("#setText_itype").val();
			var idx = $("#setText_idx").val();
			var dposi = $("#setText_dposi").val();
			if (dposi && dposi != "") {
				dposi = JSON.parse(dposi);
			} else {
				dposi = null;
			}
			var muki = $("#setText_muki").val();
			var srcId = $("#setText_srcId").val();
			InitTextData(srcId, function (tjson) {
				//console.log(tjson);

				sonbpIf.setText(itype, idx, tjson, dposi, muki, function (res) {
					console.log("setText result -->", res);
				});
			});
		});

		//テキスト削除（カレント枠）
		$("#removeText").click(function () {
			sonbpIf.removeText(function (res) {
				console.log("removeText result -->", res);
			});
		});


	};

}

$(function () {

	$(".pp").click(function () {
		var div = $("#" + this.dataset["pp"]);
		if (div.is(":hidden")) {
			div.css("display", "inline");
		} else {
			div.css("display", "none");
		}
	});
});

function EncodeFileKey(file_key: string, callback: (fkey: string) => void): void {

	const option = {
		url: "./SonbpIfTest/EncodeFileKey?fkey=" + file_key,
		type: 'GET',
		dataType: 'json',
		scriptCharset: 'utf-8',
		timeout: 10000
	};

	$.ajax(option).done((data, textStatus, jqXHR) => {
		callback(data);
	}).fail((jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
		console.error(textStatus, jqXHR);
	});
}

function InitTextData(srcId: string, callback: (json: string) => void): void {

	const option = {
		url: "./SonbpIfTest/InitTextData?srcId=" + srcId,
		type: 'GET',
		dataType: 'json',
		scriptCharset: 'utf-8',
		timeout: 10000
	};

	$.ajax(option).done((data, textStatus, jqXHR) => {
		callback(data);
	}).fail((jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
		console.error(textStatus, jqXHR);
	});
}

(<any>window).SonbpIfTestDriver = new SonbpIfTestDriver();
